import { useContext } from 'react';
import { toast } from 'react-toastify';
import { PageContext } from '../layout/pageContext';
import configAPI from '../_config/config';
import axios from '../_actions/axiosInstance';
import Notification from '../components/Notification';
// import { notificationData } from '../helpers/demo_data';

let draftNotifications = [];

const usePageContext = () => {
  const [state, setState] = useContext(PageContext);

  function getNotifications() {
    const { notificationSocket, loading } = state;
    if (notificationSocket.connected || loading) return;
    notificationSocket.connect();

    notificationSocket.on('notifications', data => {
      if (data) {
        draftNotifications = [data, ...draftNotifications]
          .filter((v, i, a) => a.findIndex(t => JSON.stringify(t) === JSON.stringify(v)) === i)
          .sort((a, b) => (a.created_on > b.created_on ? -1 : 1));
        setState({
          ...state,
          alerts: draftNotifications?.filter(n => n.action_type !== 'tagged'),
          comments: draftNotifications?.filter(n => n.action_type === 'tagged')
        });
      }
    });

    notificationSocket.on('disconnect', reason => {
      const reasonList = ['io server disconnect', 'io client disconnect', 'ping timeout'];
      if (reasonList?.includes(reason)) {
        notificationSocket.io.engine.close();
      }
    });
  }

  async function getItems() {
    let alerts = [];
    let comments = [];
    try {
      const res = await axios.get(
        configAPI.api.api_url + configAPI.api.notifications.notifications
      );
      draftNotifications = res?.data?.data;
      alerts = res?.data?.data?.filter(n => n.action_type !== 'tagged') || [];
      comments = res?.data?.data?.filter(n => n.action_type === 'tagged') || [];
    } catch (e) {
      // eslint-disable-next-line
      console.log('req or items failed');
      // eslint-disable-next-line
      console.log(e);
    }
    const newState = { ...state, firstRender: false, alerts, comments };
    setState(newState);
  }

  async function getConfig() {
    let config;
    setState({ ...state, loadingConfig: true });
    try {
      const res = await axios.get(configAPI.api.api_url + configAPI.api.notifications.configs);
      config = res.data;
    } catch (e) {
      // eslint-disable-next-line
      console.log('config req error');
    }
    setState({
      ...state,
      isOpen: state?.isOpen,
      config,
      loadingConfig: false,
      alerts: (draftNotifications || []).filter(n => n?.action_type !== 'tagged'),
      comments: (draftNotifications || []).filter(n => n?.action_type === 'tagged')
    });
  }

  async function markAsRead(nId, nType) {
    // const { notificationSocket } = state;
    const arr = state[nType];
    try {
      await axios.get(configAPI.api.api_url + configAPI.api.notifications.readNotification(nId));
      arr.forEach(e => {
        if (e.id === nId) {
          e.status = 'read';
        }
        return e;
      });
      const nextState = { ...state };
      nextState[nType] = arr;
      setState(nextState);
    } catch (e) {
      // eslint-disable-next-line
      console.log(e);
      // eslint-disable-next-line
      toast.info(<Notification title="Oops.." text={e.response.data.errors.join('<br />')} />);
    }
    // notificationSocket.emit('message-read', nId);
  }

  function changeConfig(configItem) {
    const { config, timer } = state;
    const cIndex = config.action_types.findIndex(c => c.action_type === configItem.action_type);
    config.action_types[cIndex] = configItem;
    if (timer != null) {
      window.clearTimeout(timer);
    }
    setState({
      ...state,
      config,
      timer: window.setTimeout(submitConfig, 5000)
    });
  }

  async function submitConfig() {
    const { config } = state;
    try {
      await axios.post(configAPI.api.api_url + configAPI.api.notifications.saveConfig, config);
    } catch (e) {
      // eslint-disable-next-line
      console.error(e);
      toast.info(<Notification title="Oops.." text={e.response.data.errors.join('<br />')} />);
    }
  }

  function setIsOpen(val) {
    setState({ ...state, isOpen: val });
  }

  return {
    ...state,
    getNotifications,
    markAsRead,
    changeConfig,
    submitConfig,
    getItems,
    getConfig,
    setIsOpen
  };
};

export default usePageContext;
